import React, { useEffect, useState } from 'react';
import GlobalStyle from './components/principles/GlobalStyles';
import { CookiesProvider } from 'react-cookie';
import { ThemeProvider } from 'styled-components';
import { theme } from './utils/theme';

import ScrollToTop from './utils/scrollToTop';

import CookieBanner from './components/molecule/CookieBanner';
import Page from './Page';

const App = () => {

  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <ScrollToTop />
        <GlobalStyle />
        <CookieBanner />
        <Page />
      </CookiesProvider>
    </ThemeProvider>
  );
};

export default App;
